export enum EnumNombresGrids {
  CatPptoGnrales = 'CatPptoGnrales',
  PptoCompleto = 'PptoCompleto',
  BusquedaGeneral = 'BusquedaGeneral',
  Partidas = 'Partidas',
  Conceptos = 'Conceptos',
  Matrices = 'Matrices',
  ExpIns = 'ExpIns',
  ExpInsMatriz = 'ExpInsMatriz',
  ExpInsPpto = 'ExpInsPpto',
  Unidades = 'Unidades',
  TipoInsumos = 'TipoInsumos',
  Familias = 'Familias',
  Estados = 'Estados',
  Ciudades = 'Ciudades',
  Proveedores = 'Proveedores',
  Responsables = 'Responsables',
  Clientes = 'Clientes',
  Empresas = 'Empresas',
  Vendedores = 'Vendedores',
  TiposLicitaciones = 'TiposLicitaciones',
  Regiones = 'Regiones',
  Participa = 'Participa',
  Materiales = 'Materiales',
  MO = 'ManoDeObra',
  Maquinaria = 'Maquinaria',
  Calendario = 'Calendario',
  Fechas = 'Fechas',
}

export enum EnumOtrosNombresGrids {
  JSONGrids = 'ConfiguracionGrids',
  UserDefault = 'UserDefault'
}
